function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "\\u9875\\u9762-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "\\u5728\\u7EBF\\u804A\\u5929\\uFF08\\u7BA1\\u7406\\u5E10\\u53F7\\u662F\\u7FA4\\u4E3B\\uFF09",
  transform: "translate(-216.000000, -116.000000)",
  fill: "#FFFFFF"
}, React.createElement("g", {
  id: "\\u7F16\\u7EC4-33",
  transform: "translate(216.000000, 116.000000)"
}, React.createElement("path", {
  d: "M8,0 C12.418278,0 16,3.581722 16,8 C16,12.418278 12.418278,16 8,16 C3.581722,16 0,12.418278 0,8 C0,3.581722 3.581722,0 8,0 Z M5.94939033,4.81801948 C5.6369709,4.50560005 5.13043892,4.50560005 4.81801948,4.81801948 C4.50560005,5.13043892 4.50560005,5.6369709 4.81801948,5.94939033 L6.86792204,7.99929289 L4.81801948,10.0506097 C4.50560005,10.3630291 4.50560005,10.8695611 4.81801948,11.1819805 C5.13043892,11.4943999 5.6369709,11.4943999 5.94939033,11.1819805 L7.99929289,9.13066374 L10.0506097,11.1819805 C10.3630291,11.4943999 10.8695611,11.4943999 11.1819805,11.1819805 C11.4943999,10.8695611 11.4943999,10.3630291 11.1819805,10.0506097 L9.13066374,7.99929289 L11.1819805,5.94939033 C11.4943999,5.6369709 11.4943999,5.13043892 11.1819805,4.81801948 C10.8695611,4.50560005 10.3630291,4.50560005 10.0506097,4.81801948 L8,6.86721494 L5.94939033,4.81801948 Z",
  id: "\\u5F62\\u72B6\\u5907\\u4EFD-2"
}))));

var SvgDeleteAccount = function SvgDeleteAccount(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDeleteAccount, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/deleteAccount.ad14d03e.svg";
export { ForwardRef as ReactComponent };